module.exports = __webpack_public_path__ + "img/map_dot.e48a5a07.png";